import { DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { API } from "../../Config";
import { GET } from "../../Config/ApiRequests";
import "../../Containers/VoucherScreen/style.css";

const FormModalContra = (props) => {
  const Auth = useSelector((state) => state.Auth.user);
  const formRef = useRef();
  const [form] = Form.useForm();
  const dateFormat = "YYYY-MM-DD";
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    if (!props.visible) {
      form.resetFields(); // reset the form whenever modal closes
    }
  }, [props.visible]);

  useEffect(() => {
    const initialData =
      props.mode === "post"
        ? [
            {
              key: 1,
              account_no: null,
              amount_cr: 0,
              amount_dr: 0,
            },
            {
              key: 2,
              account_no: null,
              amount_cr: 0,
              amount_dr: 0,
            },
          ]
        : [
            {
              key: 1,
              account_no: props.item?.ledger_from,
              amount_cr: 0,
              amount_dr: props.item?.amount || 0,
            },
            {
              key: 2,
              account_no: props.item?.ledger_to,
              amount_cr: props.item?.amount || 0,
              amount_dr: 0,
            },
          ];

    setDataSource(initialData);
    form.resetFields();
  }, [props.mode, props.item]);

  const handleChangeValueSet = (value, key, field) => {
    setDataSource(
      dataSource.map((item) =>
        item.key === key ? { ...item, [field]: value } : item
      )
    );
  };

  const validateAmount = async (amount) => {
    const selectedAccount = dataSource.find(
      (item) => item.key === 1
    )?.account_no;

    if (!selectedAccount || !amount) {
      return;
    }

    try {
      const response = await GET(`${API.CONTRA_VOUCHER_BALANCE}${selectedAccount}`);

      if (response.status) {
        const availableBalance = response.data;
        if (amount <= availableBalance) {
          form.setFields([
            {
              name: "amount",
              errors: [],
            },
          ]);
        } else {
          message.error("Amount exceeds available balance");
          form.setFields([
            {
              name: "amount",
              errors: ["Amount exceeds available balance"],
            },
          ]);
        }
      } else {
        message.error("Failed to retrieve account balance");
      }
    } catch (error) {
      message.error(error.message);
      console.error(error);
    }
  };

  const onFinish = (values) => {
    setLoading(true);
    const ledgerFrom = dataSource.find((item) => item.key === 1)?.account_no;
    const ledgerTo = dataSource.find((item) => item.key === 2)?.account_no;

    if (ledgerFrom === ledgerTo) {
      message.error("From Ledger and To Ledger cannot be the same");
      setLoading(false);
      return;
    }

    if (props.mode === "post") {
      props.onSave(values, ledgerFrom, ledgerTo);
    } else {
      props.onUpdate(props.item.id, values, ledgerFrom, ledgerTo);
    }

    setLoading(false);
  };

  const columns = [
    {
      title: "From Ledger",
      dataIndex: "from_ledger",
      key: "from_ledger",
      visible: true,
      width: "50%",
      render: (text, record, index) => {
        const toLedger = dataSource.find((item) => item.key === 2)?.account_no;
        return (
          <Form.Item
            style={{ padding: 0, margin: 0 }}
            name={["list", 1, "account_no"]}
            rules={[{ required: true, message: "Required" }]}
          >
            <Select
              bordered={false}
              className="CustomerForm-Select"
              showSearch
              allowClear
              placeholder="From"
              filterOption={(input, option) => {
                const accountNo = option.value.toLowerCase();
                const accountName = option.children.toString().toLowerCase();
                return (
                  accountNo.includes(input.toLowerCase()) ||
                  accountName.includes(input.toLowerCase())
                );
              }}
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "0px",
              }}
              onChange={(value) => {
                handleChangeValueSet(value, 1, "account_no");
                form.setFieldsValue({ amount: null }); // Clear the amount field
                const currentAmount = form.getFieldValue("amount");
                if (currentAmount) {
                  validateAmount(currentAmount);
                }
              }}
            >
              {props.accounts
                .filter((item) => item.account_no !== toLedger)
                .map((item) => (
                  <Select.Option key={item.account_no} value={item.account_no}>
                    {item.account_no} - {item.account_name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: "To Ledger",
      dataIndex: "to_ledger",
      key: "to_ledger",
      visible: true,
      width: "50%",
      render: (text, record, index) => {
        const fromLedger = dataSource.find(
          (item) => item.key === 1
        )?.account_no;
        return (
          <Form.Item
            style={{ padding: 0, margin: 0 }}
            name={["list", 2, "account_no"]}
            rules={[{ required: true, message: "Required" }]}
          >
            <Select
              bordered={false}
              className="CustomerForm-Select"
              showSearch
              allowClear
              placeholder="To"
              filterOption={(input, option) => {
                const accountNo = option.value.toLowerCase();
                const accountName = option.children.toString().toLowerCase();
                return (
                  accountNo.includes(input.toLowerCase()) ||
                  accountName.includes(input.toLowerCase())
                );
              }}
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "0px",
              }}
              onChange={(value) => handleChangeValueSet(value, 2, "account_no")}
            >
              {props.accounts
                .filter((item) => item.account_no !== fromLedger)
                .map((item) => (
                  <Select.Option key={item.account_no} value={item.account_no}>
                    {item.account_no} - {item.account_name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    },
  ];

  return (
    <Modal
      title={props.head || props.columnsVisible.page}
      centered
      open={props.visible}
      onOk={props.onClose}
      onCancel={() => props.onClose()}
      width={1000}
      footer={false}
      style={{ borderRadius: 10 }}
    >
      <Form
        form={form}
        ref={formRef}
        onFinish={onFinish}
        initialValues={{
          voucher_date:
            props.mode === "post" ? moment() : moment(props.item?.voucher_date),
          description: props.item?.description,
          amount: props.item?.amount,
          list: {
            1: { account_no: props.item?.ledger_from },
            2: { account_no: props.item?.ledger_to },
          },
        }}
        hideRequiredMark
      >
        <Row gutter={[6, 6]}>
          <Col xs={24} md={12}>
            <Form.Item
              style={{ marginBottom: "0px" }}
              labelCol={{ span: 7 }}
              wrapperCol={{ span: 16 }}
              name="voucher_date"
              label="Voucher Date"
              rules={[{ required: true, message: "Required" }]}
            >
              <DatePicker
                size="large"
                format={dateFormat}
                placeholder="Pick a date"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              style={{ marginBottom: "0px" }}
              labelCol={{ span: 7 }}
              wrapperCol={{ span: 16 }}
              name="amount"
              label="Amount"
              rules={[
                { required: true, message: "Required" },
                {
                  type: "number",
                  min: 0,
                  message: "Please enter a valid number",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                size="large"
                placeholder="Amount"
                type="number"
                min={0}
                onKeyDown={(e) => {
                  if (e.key === "e" || e.key === "E") {
                    e.preventDefault();
                  }
                }}
                onChange={(value) => validateAmount(value)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              labelCol={{ span: 7 }}
              wrapperCol={{ span: 16 }}
              name="description"
              label="Description"
              rules={[{ required: true, message: "Description is required" }]}
            >
              <Input.TextArea
                rows={2}
                size="small"
                placeholder="Enter Remarks"
              />
            </Form.Item>
          </Col>
        </Row>
        <Table
          className="my-table"
          dataSource={[{}]}
          columns={columns.filter((column) => column.visible)}
          pagination={false}
          size="small"
          bordered
          rowKey="key"
        />
        <Row justify="end">
          <Col sm={6} xs={12} style={{ padding: "10px" }}>
            <Button onClick={props.onClose} block>
              Cancel
            </Button>
          </Col>
          <Col sm={6} xs={12} style={{ padding: "10px" }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              {props.mode === "post" ? "Save" : "Update"}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default FormModalContra;
